import styled from 'styled-components';

import { HueTextInput } from '../HueTextInput';

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	border-radius: 5px;
	background-color: rgba(0, 0, 0, 0.1);
`;

const StyledInputContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	justify-content: space-between;
`;

const StyledHexTextInput = styled(HueTextInput).attrs({
	maxLength: 6,
	spellCheck: false,
	tabIndex: -1,
} as React.HTMLAttributes<HTMLInputElement>)`
	width: 90px;
	height: 40px;
	padding-left: 25px;
`;

const StyledRgbTextInput = styled(HueTextInput).attrs({
	type: 'number',
	min: 0,
	max: 255,
	tabIndex: -1,
} as React.HTMLAttributes<HTMLInputElement>)`
	width: 60px;
	height: 40px;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

const StyledRgbContainer = styled.div`
	display: flex;
	gap: 10px;
`;

export {
	StyledDot,
	StyledHexTextInput,
	StyledInputContainer,
	StyledRgbContainer,
	StyledRgbTextInput,
};
